export default function isHtmlVideoElement<T extends HTMLVideoElement>(
  item?: T | object | null
): item is T {
  if (!item) return false;

  return item instanceof HTMLVideoElement;
}
